import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getIncomingAuthorizeParams, getOrCreateRequestId, persistAppUrl, extractAgencyIdFromSaml } from '../../reducers/auth/authAuthorizeHelpers';
import { getCustomerAppInfoRequest } from '../../backend/authRequests';
import { to } from '../../lib/requestHelpers';
import { replaceGoToBaseUrl } from '../../lib/samlAuthHelpers';
import { AUTH_SERVER_ERROR_MODAL_OPEN,updateAuthState } from '../../reducers/auth/authActions';

function SamlAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const params = getIncomingAuthorizeParams();
    // Extract client_id from incoming authorize params
    const spEntityID = params?.spEntityID;
    const rawGoToUrl = params?.goto ?? null;
    const goToUrl = replaceGoToBaseUrl(rawGoToUrl);

    if (!spEntityID) {
      navigate('/sign-in', { replace: true });
      return;
    }

    const requestId = getOrCreateRequestId();
    const agencyId = extractAgencyIdFromSaml(spEntityID);
    
    dispatch(
      updateAuthState({
        requestId,
        clientId: spEntityID,
        goToUrl,
        authType: 'saml',
        agencyId,
      }),
    );

    const customerAppInfo = async () => {
      const [result, err] = await to(dispatch(getCustomerAppInfoRequest({
        agencyId,
        uniqueIdentifier: requestId,
        customerAppClientId: spEntityID,
        forwardedHost: window.location.host,
      })));

      const responseBody = result?.body || {};
      const responseStatus = result?.response?.status;
      const appUrl = responseBody.appUrl ?? null;
      const appName = responseBody.appName ?? null;
      const customerAppId = responseBody.customerAppId ?? null;

      if (err || responseStatus !== 200) {
        dispatch({
          type: AUTH_SERVER_ERROR_MODAL_OPEN,
          payload: {
            uniqueIdentifier: requestId,
          },
        });
        return;
      }

      if (appUrl) {
        persistAppUrl(appUrl);
      }

      dispatch(
        updateAuthState({
          appName,
          appUrl,
          customerAppId,
          agencyId,
          utmParams: {
            utm_source: responseBody.utmSource ?? '',
            utm_medium: responseBody.utmMedium ?? '',
            utm_campaign: responseBody.utmCampaign ?? '',
          },
        }),
      );

      navigate('/sign-in', { replace: true });
    };

    customerAppInfo();

  }, [dispatch, navigate]);

  return (
    <div className="sign-in-page">
      <div className="sign-in-card">
        <div className="sign-in-card-body">
          <div className="sign-in-loading" role="status" aria-label="Loading" />
        </div>
      </div>
    </div>
  );
}

export default SamlAuth;
